module.exports = __webpack_public_path__ + "static/parcelhoc-baedb7ff26ea00e762a8b5a4b1254630.gif";